export default __webpack_public_path__ + "static/media/30-color.ba6a8144.svg";